import { useContext } from 'react';
import { ApplicationContext } from '../application-context';

export const useScrollPosition = () => {
  const applicationContext = useContext(ApplicationContext);
  return applicationContext.scrollPosition;
};

